<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr && form.beforeStr.lecturerMap">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="item">讲师名称：{{form.beforeStr.lecturerMap.real_name}}</div>
          <div class="item">性别：{{form.beforeStr.lecturerMap.sex === 1?'男':(form.beforeStr.lecturerMap.sex === 2?'女':'')}}</div>
          <div class="item">头像：<el-image style="width: 50px; height: 50px" :src="form.beforeStr.lecturerMap.profile_photo_mini" :preview-src-list="[form.beforeStr.lecturerMap.profile_photo_mini]"></el-image></div>
          <div class="item">形象图：<el-image style="width: 50px; height: 50px" :src="form.beforeStr.lecturerMap.profile_photo" :preview-src-list="[form.beforeStr.lecturerMap.profile_photo]"></el-image></div>
          <div class="item">手机号：{{form.beforeStr.lecturerMap.mobile}}</div>
          <div class="item">个人简介：{{form.beforeStr.lecturerMap.profile_desc}}</div>
          <div class="item">状态：{{form.beforeStr.lecturerMap.state?'启用':'禁用'}}</div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr && form.afterStr.lecturerMap">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="item">讲师名称：{{form.afterStr.lecturerMap.real_name}}</div>
          <div class="item">性别：{{form.afterStr.lecturerMap.sex === 1?'男':(form.afterStr.lecturerMap.sex === 2?'女':'')}}</div>
          <div class="item">头像：<el-image style="width: 50px; height: 50px" :src="form.afterStr.lecturerMap.profile_photo_mini" :preview-src-list="[form.afterStr.lecturerMap.profile_photo_mini]"></el-image></div>
          <div class="item">形象图：<el-image style="width: 50px; height: 50px" :src="form.afterStr.lecturerMap.profile_photo" :preview-src-list="[form.afterStr.lecturerMap.profile_photo]"></el-image></div>
          <div class="item">手机号：{{form.afterStr.lecturerMap.mobile}}</div>
          <div class="item">个人简介：{{form.afterStr.lecturerMap.profile_desc}}</div>
          <div class="item">状态：{{form.afterStr.lecturerMap.state?'启用':'禁用'}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
